import { useRecoilState } from 'recoil'
import SubscriberStore from '../atoms/subscriber'

export default function useSubscriberStore() {
  return useRecoilState(SubscriberStore)
}
